import React from "react";

import "./myTabs.scss"

export default class MyTabs extends React.Component{
    constructor(props){
        super(props);
        this.state={
            
            activeId:''
        }
        
    }
    static defaultProps={
        data:[]
        
    }
    cli(s){
        this.setState({
            activeId:s.value
        })
        this.props.back(s)
    }
    render(){
        let that=this;
        return(
            <div style={this.props.style} className="MyTabs">
                {
                    this.props.data.map((s)=>{
                        return <div key={s.value} className={this.state.activeId==s.value?"active":""} onClick={()=>{this.cli(s)}}>{s.name}</div>
                    })
                }
                
            </div>
        )
    }
    componentWillReceiveProps(nextProps) {
        
        
        
    }
    componentDidMount(){
       this.setState({
            activeId:this.props.data[0].value||""
       })
    }
}

